import { rgba } from 'polished';

import { colors } from './colors';
import { borders } from './borders';

export interface INavigationTheme {
  backgroundColor: string;
  borderColor: string;
  border: string;
  inverseBorder: string;
  downloadAppBackground: string;
  downloadAppBorder: string;
  downloadAppText: string;
  gradient: string;
  headerBackgroundColor: string;
  lightBorder: string;
  lightBorderTwo: string;
  loaderColor: string;
  mainBorderColor: string;
  missingAssetPath: string;
  searchBorderColor: string;
  textColor: string;
  buttonHoverBackground: string;
}

interface INavigationThemes {
  dark: INavigationTheme;
  light: INavigationTheme;
}

export const navigationThemes: INavigationThemes = {
  dark: {
    backgroundColor: colors.black,
    headerBackgroundColor: colors.black,
    borderColor: rgba(colors.white, 0.7),
    border: borders.white,
    inverseBorder: borders.black,
    downloadAppBackground: colors.offBlack,
    downloadAppBorder: colors.offBlack,
    downloadAppText: colors.darkGray,
    gradient: `linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9))`,
    lightBorder: rgba(colors.white, 0.3),
    lightBorderTwo: rgba(colors.white, 0.35),
    loaderColor: colors.white,
    mainBorderColor: rgba(colors.white, 0.7),
    missingAssetPath: 'https://cms-cdn.goat.com/2fb8a5a0ad5f-549a-ce11-6113-0e55ec6b.png',
    searchBorderColor: colors.black,
    textColor: colors.white,
    buttonHoverBackground: colors.white,
  },
  light: {
    backgroundColor: colors.white,
    headerBackgroundColor: colors.white,
    borderColor: rgba(colors.black, 0.7),
    border: borders.black,
    inverseBorder: borders.white,
    downloadAppBackground: colors.white,
    downloadAppBorder: rgba(colors.black, 0.7),
    downloadAppText: colors.black,
    gradient: `linear-gradient(to top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.9))`,
    loaderColor: colors.black,
    lightBorder: colors.black,
    lightBorderTwo: rgba(colors.black, 0.35),
    mainBorderColor: rgba(colors.black, 0.7),
    missingAssetPath: 'https://cms-cdn.goat.com/44f2a1cd1d5e-bb39-ce11-2213-0647c51f.png',
    searchBorderColor: rgba(colors.black, 0.7),
    textColor: colors.black,
    buttonHoverBackground: colors.black,
  },
};
